import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Share2, Download } from "lucide-react";
import Image1 from "../../../assets/gallery/i1.webp";
import Image2 from "../../../assets/gallery/i2.webp";
import Image3 from "../../../assets/gallery/i3.webp";
import Image4 from "../../../assets/gallery/i4.webp";
import Image5 from "../../../assets/gallery/i5.webp";
import Image6 from "../../../assets/gallery/i6.webp";
import Image7 from "../../../assets/gallery/i7.webp";
import Image8 from "../../../assets/gallery/i8.webp";
import "./Media.css";

const row1 = [Image1, Image2, Image3, Image4,Image5, Image6, Image7, Image8];


export function ScrollingGallery() {
  const [activeImg, setActiveImg] = useState(null);

  const handleShare = async (img) => {
    if (navigator.share) {
      await navigator.share({
        title: "IHN Media Gallery",
        url: img,
      });
    } else {
      window.open(`https://wa.me/?text=${encodeURIComponent(img)}`);
    }
  };

  const GalleryImage = ({ img }) => (
    <div
      className="gallery-thumb"
      onClick={() => setActiveImg(img)} // for mobile
    >
      <img src={img} alt="Gallery" />
    </div>
  );

  return (
    <div>


      <div className="scrolling-container">
        {/* Row 1 */}
        <div className="scroll-row">
          <motion.div
            className="scroll-track"
            animate={{ x: [0, -1000] }}
            transition={{ repeat: Infinity, duration: 20, ease: "linear" }}
          >
            {[...row1, ...row1].map((img, i) => (
              <GalleryImage img={img} key={i} />
            ))}
          </motion.div>
        </div>
      </div>

      {/* FULL SCREEN ON HOVER */}
      <AnimatePresence>
        {activeImg && (
          <motion.div
            className="hover-lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setActiveImg(null)}
          >

            <motion.img
              src={activeImg}
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.9 }}
              onClick={(e) => e.stopPropagation()}
            />

            <div className="lightbox-actions">
              <button onClick={() => handleShare(activeImg)}>
                <Share2 size={20} />

              </button>

              <a href={activeImg} download>
                <Download size={20} />

              </a>
            </div>

            <button
              className="close-lightbox"
              onClick={() => setActiveImg(null)}
            >
              <X size={28} />
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
